export const theme = {
  colors: {
    text: '#4c4f51',
    title: '#2c3338',
    background: '#ffffff',
    hover: '#64baf3c7',
    border: '#dcdcde',
    action: 'rgba(0, 0, 255, 0.5)',
  },

  fonts: {
    body: 'Roboto, san-sarif',
  },

  space: [0, 2, 4, 8, 18, 32, 64, 128, 256],

  fontSizes: {
    s: 10,
    m: 15,
    l: 20,
    xl: 30,
  },

  fontWeights: {
    bolder: 700,
  },

  border: {
    normal: '2px solid',
  },

  radii: {
    round: '50%',
    normal: '4px',
  },

  shadows: {
    profile: '0 0 2px 1px rgba(0, 0, 255, 0.3)',
  },
};
